
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('account-management-address') && (binding.modules['account-management-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-management-address' */
            'partner/common/citta-address/modules/account-management-address/account-management-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'common/citta-address/actions/get-address-purposes', runOn: 0},{name:'countryRegions',  path:'common/citta-address/actions/get-country-regions', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'account-management-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/common/citta-address/modules/account-management-address'
    });
        

    isNotRegistered('alphabet-list') && (binding.modules['alphabet-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-alphabet-list' */
            'partner/modules/alphabet-list/alphabet-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'alphabet-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/alphabet-list'
    });
        

    isNotRegistered('b2b-citta-invoices-list') && (binding.modules['b2b-citta-invoices-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-b2b-citta-invoices-list' */
            'partner/modules/b2b-citta-invoices-list/b2b-citta-invoices-list.tsx'),
        $type: 'contentModule',
        da: [{name:'b2bUserInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user', runOn: 0},{name:'customer',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'customerBalance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'invoices',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'b2b-citta-invoices-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/b2b-citta-invoices-list'
    });
        

    isNotRegistered('business-account-address') && (binding.modules['business-account-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-business-account-address' */
            'partner/common/citta-address/modules/business-account-address/business-account-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'common/citta-address/actions/get-address-purposes', runOn: 0},{name:'countryRegions',  path:'common/citta-address/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'common/citta-address/actions/get-country-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'business-account-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/common/citta-address/modules/business-account-address'
    });
        

    isNotRegistered('checkout-billing-address') && (binding.modules['checkout-billing-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-billing-address' */
            'partner/common/citta-address/modules/checkout-billing-address/checkout-billing-address.tsx'),
        $type: 'contentModule',
        da: [{name:'addressPurposes',  path:'common/citta-address/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'common/citta-address/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'common/citta-address/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-billing-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/common/citta-address/modules/checkout-billing-address'
    });
        

    isNotRegistered('checkout-guest-profile-emarsys') && (binding.modules['checkout-guest-profile-emarsys'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-guest-profile-emarsys' */
            'partner/modules/checkout-guest-profile-emarsys/checkout-guest-profile-emarsys.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-guest-profile-emarsys',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-guest-profile-emarsys'
    });
        

    isNotRegistered('checkout-section-container') && (binding.modules['checkout-section-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-section-container' */
            'partner/modules/checkout-section-container/checkout-section-container.tsx'),
        $type: 'containerModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-section-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/checkout-section-container'
    });
        

    isNotRegistered('checkout-shipping-address') && (binding.modules['checkout-shipping-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-shipping-address' */
            'partner/common/citta-address/modules/checkout-shipping-address/checkout-shipping-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'common/citta-address/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'common/citta-address/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'common/citta-address/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'checkout-shipping-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/common/citta-address/modules/checkout-shipping-address'
    });
        

    isNotRegistered('citta') && (binding.modules['citta'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta' */
            'partner/themes/citta/citta.tsx'),
        $type: 'themeModule',
        da: [{name:'accordionExpandedState',  path:'data-actions/accordion/accordion-state-data-action', moduleName: 'accordion-item',runOn: 0},{name:'categoryPaths',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths', moduleName: 'buybox',runOn: 0},{name:'categoryPaths',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths', moduleName: 'order-confirmation',runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', moduleName: 'buybox',runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', moduleName: 'order-confirmation',runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', moduleName: 'order-details',runOn: 0},{name:'productAttributes',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant', moduleName: 'buybox',runOn: 0},{name:'productAvailability',  path:'actions/custom-get-product-availabilities-for-selected-variant', moduleName: 'buybox',runOn: 0},{name:'productDimensions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant', moduleName: 'buybox',runOn: 0},{name:'productSpecificationData',  path:'data-actions/accordion/get-attributes-for-selected-variant', moduleName: 'accordion-item',runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', moduleName: 'buybox',runOn: 1}],
        definitionExtensions: ['accordion-item','buybox','cart','checkout-guest-profile','checkout-shipping-address','checkout','citta-cart','citta-checkout','content-block','footer-category','header','invoice-details','navigation-menu','order-confirmation','order-details','promo-banner','sign-up','text-block','video-player'],
        iNM: false,
        ns: '__local__',
        n: 'citta',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'citta.theme.settings.json',
        md: 'src/themes/citta'
    });
        

    isNotRegistered('citta-accordion-custom') && (binding.modules['citta-accordion-custom'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-accordion-custom' */
            'partner/modules/citta-accordion-custom/citta-accordion-custom.tsx'),
        $type: 'containerModule',
        da: [{name:'accordionExpandedState',  path:'data-actions/accordion/accordion-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-accordion-custom',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-accordion-custom'
    });
        

    isNotRegistered('citta-accordion-item-custom') && (binding.modules['citta-accordion-item-custom'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-accordion-item-custom' */
            'partner/modules/citta-accordion-item-custom/citta-accordion-item-custom.tsx'),
        $type: 'containerModule',
        da: [{name:'accordionExpandedState',  path:'data-actions/accordion/accordion-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-accordion-item-custom',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-accordion-item-custom'
    });
        

    isNotRegistered('citta-account-management-address') && (binding.modules['citta-account-management-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-account-management-address' */
            'partner/modules/citta-account-management-address/citta-account-management-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'data-actions/address/get-address-purposes', runOn: 0},{name:'countryRegions',  path:'data-actions/address/get-country-regions', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-account-management-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-account-management-address'
    });
        

    isNotRegistered('citta-account-subscription') && (binding.modules['citta-account-subscription'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-account-subscription' */
            'partner/modules/citta-account-subscription/citta-account-subscription.tsx'),
        $type: 'contentModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-account-subscription',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-account-subscription'
    });
        

    isNotRegistered('citta-anchor') && (binding.modules['citta-anchor'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-anchor' */
            'partner/modules/citta-anchor/citta-anchor.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-anchor',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-anchor'
    });
        

    isNotRegistered('citta-b2b-account-profile') && (binding.modules['citta-b2b-account-profile'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-b2b-account-profile' */
            'partner/modules/citta-b2b-account-profile/citta-b2b-account-profile.tsx'),
        $type: 'contentModule',
        da: [{name:'attributeDefinitions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-b2b-account-profile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-b2b-account-profile'
    });
        

    isNotRegistered('citta-b2b-account-welcome-tile') && (binding.modules['citta-b2b-account-welcome-tile'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-b2b-account-welcome-tile' */
            'partner/modules/citta-b2b-account-welcome-tile/citta-b2b-account-welcome-tile.tsx'),
        $type: 'contentModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-b2b-account-welcome-tile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-b2b-account-welcome-tile'
    });
        

    isNotRegistered('citta-b2b-wishlist-items') && (binding.modules['citta-b2b-wishlist-items'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-b2b-wishlist-items' */
            'partner/modules/citta-b2b-wishlist-items/citta-b2b-wishlist-items.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'productAvailability',  path:'modules/citta-b2b-wishlist-items/actions/get-product-availabilities-citta-b2b-wishlist-items', runOn: 1},{name:'products',  path:'modules/citta-b2b-wishlist-items/actions/get-items-in-wishlists', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-b2b-wishlist-items',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-b2b-wishlist-items'
    });
        

    isNotRegistered('citta-bloc-form') && (binding.modules['citta-bloc-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-bloc-form' */
            'partner/modules/citta-bloc-form/citta-bloc-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-bloc-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-bloc-form'
    });
        

    isNotRegistered('citta-buybox') && (binding.modules['citta-buybox'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-buybox' */
            'partner/modules/citta-buybox/citta-buybox.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'categoryPaths',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths', runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productAttributes',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant', runOn: 0},{name:'productAvailability',  path:'actions/custom-get-product-availabilities-for-selected-variant', runOn: 0},{name:'productAvailableQuantity',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant', runOn: 0},{name:'productDimensions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant', runOn: 0},{name:'productPrice',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant', runOn: 0},{name:'ratingsSummary',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-buybox',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-buybox'
    });
        

    isNotRegistered('citta-cart') && (binding.modules['citta-cart'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-cart' */
            'partner/modules/citta-cart/citta-cart.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'cartLinesPickUpOptions',  path:'modules/citta-cart/actions/get-pickup-options-for-citta-cartlines', runOn: 0},{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 0},{name:'productAvailabilites',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines', runOn: 0},{name:'products',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1},{name:'wishlistItems',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-cart',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-cart'
    });
        

    isNotRegistered('citta-category-navigation-menu') && (binding.modules['citta-category-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-category-navigation-menu' */
            'partner/modules/citta-category-navigation-menu/citta-category-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-category-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-category-navigation-menu'
    });
        

    isNotRegistered('citta-checkout') && (binding.modules['citta-checkout'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout' */
            'partner/modules/citta-checkout/citta-checkout.tsx'),
        $type: 'containerModule',
        da: [{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/citta-checkout/actions/get-products-in-active-citta-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout'
    });
        

    isNotRegistered('citta-checkout-billing-address') && (binding.modules['citta-checkout-billing-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-billing-address' */
            'partner/modules/citta-checkout-billing-address/citta-checkout-billing-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'data-actions/address/get-address-purposes', runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'data-actions/address/get-country-regions', runOn: 0},{name:'countryStates',  path:'data-actions/address/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'shippingType',  path:'data-actions/click-and-collect/shipping-types', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-billing-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-billing-address'
    });
        

    isNotRegistered('citta-checkout-customer-account-payment') && (binding.modules['citta-checkout-customer-account-payment'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-customer-account-payment' */
            'partner/modules/citta-checkout-customer-account-payment/citta-checkout-customer-account-payment.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'creditBalances',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-customer-account-payment',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-customer-account-payment'
    });
        

    isNotRegistered('citta-checkout-delivery-options') && (binding.modules['citta-checkout-delivery-options'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-delivery-options' */
            'partner/modules/citta-checkout-delivery-options/citta-checkout-delivery-options.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-delivery-options',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-delivery-options'
    });
        

    isNotRegistered('citta-checkout-gift-card') && (binding.modules['citta-checkout-gift-card'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-gift-card' */
            'partner/modules/citta-checkout-gift-card/citta-checkout-gift-card.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-gift-card',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-gift-card'
    });
        

    isNotRegistered('citta-checkout-guest-profile') && (binding.modules['citta-checkout-guest-profile'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-guest-profile' */
            'partner/modules/citta-checkout-guest-profile/citta-checkout-guest-profile.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-guest-profile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-guest-profile'
    });
        

    isNotRegistered('citta-checkout-gwp') && (binding.modules['citta-checkout-gwp'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-gwp' */
            'partner/modules/citta-checkout-gwp/citta-checkout-gwp.tsx'),
        $type: 'containerModule',
        da: [{name:'cartConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration', runOn: 0},{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/citta-checkout-gwp/actions/get-products-in-active-citta-checkout-gwp-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-gwp',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-gwp'
    });
        

    isNotRegistered('citta-checkout-ogty') && (binding.modules['citta-checkout-ogty'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-ogty' */
            'partner/modules/citta-checkout-ogty/citta-checkout-ogty.tsx'),
        $type: 'containerModule',
        da: [{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/citta-checkout-ogty/actions/get-products-in-active-citta-checkout-ogty-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-ogty',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-ogty'
    });
        

    isNotRegistered('citta-checkout-payment-instrument') && (binding.modules['citta-checkout-payment-instrument'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-payment-instrument' */
            'partner/modules/citta-checkout-payment-instrument/citta-checkout-payment-instrument.tsx'),
        $type: 'contentModule',
        da: [{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'products',  path:'@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-payment-instrument',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-payment-instrument'
    });
        

    isNotRegistered('citta-checkout-payment-instrument-afterpay') && (binding.modules['citta-checkout-payment-instrument-afterpay'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-payment-instrument-afterpay' */
            'partner/modules/citta-checkout-payment-instrument-afterpay/citta-checkout-payment-instrument-afterpay.tsx'),
        $type: 'contentModule',
        da: [{name:'cardPaymentAcceptPoint',  path:'modules/citta-checkout-payment-instrument-afterpay/actions/get-card-payment-accept-point', runOn: 1},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'products',  path:'@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-payment-instrument-afterpay',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-payment-instrument-afterpay'
    });
        

    isNotRegistered('citta-checkout-shipping-address') && (binding.modules['citta-checkout-shipping-address'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-shipping-address' */
            'partner/modules/citta-checkout-shipping-address/citta-checkout-shipping-address.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'data-actions/address/get-address-purposes', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'data-actions/address/get-country-regions', runOn: 0},{name:'countryStates',  path:'data-actions/address/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-shipping-address',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-shipping-address'
    });
        

    isNotRegistered('citta-checkout-shipping-address-intl') && (binding.modules['citta-checkout-shipping-address-intl'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-checkout-shipping-address-intl' */
            'partner/modules/citta-checkout-shipping-address-intl/citta-checkout-shipping-address-intl.tsx'),
        $type: 'contentModule',
        da: [{name:'address',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-address', runOn: 0},{name:'addressPurposes',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'countryRegions',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions', runOn: 0},{name:'countryStates',  path:'@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-checkout-shipping-address-intl',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-checkout-shipping-address-intl'
    });
        

    isNotRegistered('citta-collapsible-recommendations') && (binding.modules['citta-collapsible-recommendations'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-collapsible-recommendations' */
            'partner/modules/citta-collapsible-recommendations/citta-collapsible-recommendations.tsx'),
        $type: 'moduleDefinition',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-collapsible-recommendations',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-collapsible-recommendations'
    });
        

    isNotRegistered('citta-commercial-header') && (binding.modules['citta-commercial-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-commercial-header' */
            'partner/modules/citta-commercial-header/citta-commercial-header.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-commercial-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-commercial-header'
    });
        

    isNotRegistered('citta-competition-form') && (binding.modules['citta-competition-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-competition-form' */
            'partner/modules/citta-competition-form/citta-competition-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-competition-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-competition-form'
    });
        

    isNotRegistered('citta-contact') && (binding.modules['citta-contact'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-contact' */
            'partner/modules/citta-contact/citta-contact.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-contact',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-contact'
    });
        

    isNotRegistered('citta-contact-commercial') && (binding.modules['citta-contact-commercial'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-contact-commercial' */
            'partner/modules/citta-contact-commercial/citta-contact-commercial.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-contact-commercial',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-contact-commercial'
    });
        

    isNotRegistered('citta-create-gift-card') && (binding.modules['citta-create-gift-card'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-create-gift-card' */
            'partner/modules/citta-create-gift-card/citta-create-gift-card.tsx'),
        $type: 'moduleDefinition',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'configErrorState',  path:'data-actions/product-info/get-product-configure-error-state', runOn: 0},{name:'keyedInPrice',  path:'data-actions/product-info/get-keyed-in-price', runOn: 0},{name:'keyedInPriceError',  path:'data-actions/product-info/get-keyed-in-price-error', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'quantity',  path:'data-actions/product-info/get-selected-quantity', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-create-gift-card',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-create-gift-card'
    });
        

    isNotRegistered('citta-custom-navigation-menu') && (binding.modules['citta-custom-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-custom-navigation-menu' */
            'partner/modules/citta-custom-navigation-menu/citta-custom-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-custom-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-custom-navigation-menu'
    });
        

    isNotRegistered('citta-emarsys-form') && (binding.modules['citta-emarsys-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-emarsys-form' */
            'partner/modules/citta-emarsys-form/citta-emarsys-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-emarsys-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-emarsys-form'
    });
        

    isNotRegistered('citta-enquire-form') && (binding.modules['citta-enquire-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-enquire-form' */
            'partner/modules/citta-enquire-form/citta-enquire-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-enquire-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-enquire-form'
    });
        

    isNotRegistered('citta-enquirenow') && (binding.modules['citta-enquirenow'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-enquirenow' */
            'partner/modules/citta-enquirenow/citta-enquirenow.tsx'),
        $type: 'moduleDefinition',
        da: [{name:'accordionExpandedState',  path:'data-actions/accordion/accordion-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-enquirenow',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-enquirenow'
    });
        

    isNotRegistered('citta-enquireonly-buybox') && (binding.modules['citta-enquireonly-buybox'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-enquireonly-buybox' */
            'partner/modules/citta-enquireonly-buybox/citta-enquireonly-buybox.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productAvailableQuantity',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant', runOn: 0},{name:'productDimensions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant', runOn: 0},{name:'productPrice',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant', runOn: 0},{name:'ratingsSummary',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-enquireonly-buybox',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-enquireonly-buybox'
    });
        

    isNotRegistered('citta-footer-category') && (binding.modules['citta-footer-category'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-footer-category' */
            'partner/modules/citta-footer-category/citta-footer-category.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-footer-category',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-footer-category'
    });
        

    isNotRegistered('citta-footer-item') && (binding.modules['citta-footer-item'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-footer-item' */
            'partner/modules/citta-footer-item/citta-footer-item.tsx'),
        $type: 'moduleDefinition',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-footer-item',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-footer-item'
    });
        

    isNotRegistered('citta-freight-charges') && (binding.modules['citta-freight-charges'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-freight-charges' */
            'partner/modules/citta-freight-charges/citta-freight-charges.tsx'),
        $type: 'moduleDefinition',
        da: [{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'currentQuantity',  path:'data-actions/product-info/get-selected-quantity', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productAttributes',  path:'data-actions/product-info/get-attributes-for-selected-variant', runOn: 0},{name:'productQuantityState',  path:'data-actions/product-quantity/product-quantity-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-freight-charges',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-freight-charges'
    });
        

    isNotRegistered('citta-gift-card-balance-check') && (binding.modules['citta-gift-card-balance-check'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-gift-card-balance-check' */
            'partner/modules/citta-gift-card-balance-check/citta-gift-card-balance-check.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-gift-card-balance-check',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-gift-card-balance-check'
    });
        

    isNotRegistered('citta-gift-card-container') && (binding.modules['citta-gift-card-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-gift-card-container' */
            'partner/modules/citta-gift-card-container/citta-gift-card-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-gift-card-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-gift-card-container'
    });
        

    isNotRegistered('citta-gift-card-creation') && (binding.modules['citta-gift-card-creation'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-gift-card-creation' */
            'partner/modules/citta-gift-card-creation/citta-gift-card-creation.tsx'),
        $type: 'moduleDefinition',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration', runOn: 0},{name:'configErrorState',  path:'data-actions/product-info/get-product-configure-error-state', runOn: 0},{name:'keyedInPrice',  path:'data-actions/product-info/get-keyed-in-price', runOn: 0},{name:'keyedInPriceError',  path:'data-actions/product-info/get-keyed-in-price-error', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'quantity',  path:'data-actions/product-info/get-selected-quantity', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-gift-card-creation',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-gift-card-creation'
    });
        

    isNotRegistered('citta-header') && (binding.modules['citta-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-header' */
            'partner/modules/citta-header/citta-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-header'
    });
        

    isNotRegistered('citta-homepage-banner') && (binding.modules['citta-homepage-banner'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-homepage-banner' */
            'partner/modules/citta-homepage-banner/citta-homepage-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-homepage-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-homepage-banner'
    });
        

    isNotRegistered('citta-inv-dlv-banner') && (binding.modules['citta-inv-dlv-banner'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-inv-dlv-banner' */
            'partner/modules/citta-inv-dlv-banner/citta-inv-dlv-banner.tsx'),
        $type: 'contentModule',
        da: [{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-inv-dlv-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-inv-dlv-banner'
    });
        

    isNotRegistered('citta-journal-competition-form') && (binding.modules['citta-journal-competition-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-journal-competition-form' */
            'partner/modules/citta-journal-competition-form/citta-journal-competition-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-journal-competition-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-journal-competition-form'
    });
        

    isNotRegistered('citta-journal-posts') && (binding.modules['citta-journal-posts'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-journal-posts' */
            'partner/modules/citta-journal-posts/citta-journal-posts.tsx'),
        $type: 'contentModule',
        da: [{name:'journals',  path:'data-actions/journal/get-journal-posts', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-journal-posts',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-journal-posts'
    });
        

    isNotRegistered('citta-lightbox') && (binding.modules['citta-lightbox'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-lightbox' */
            'partner/modules/citta-lightbox/citta-lightbox.tsx'),
        $type: 'moduleDefinition',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-lightbox',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-lightbox'
    });
        

    isNotRegistered('citta-media-gallery') && (binding.modules['citta-media-gallery'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-media-gallery' */
            'partner/modules/citta-media-gallery/citta-media-gallery.tsx'),
        $type: 'contentModule',
        da: [{name:'mediaLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-media-gallery',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-media-gallery'
    });
        

    isNotRegistered('citta-n-tile-list-item') && (binding.modules['citta-n-tile-list-item'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-n-tile-list-item' */
            'partner/modules/citta-n-tile-list-item/citta-n-tile-list-item.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-n-tile-list-item',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-n-tile-list-item'
    });
        

    isNotRegistered('citta-navigation-menu') && (binding.modules['citta-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-navigation-menu' */
            'partner/modules/citta-navigation-menu/citta-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-navigation-menu'
    });
        

    isNotRegistered('citta-newsletter-subscribe') && (binding.modules['citta-newsletter-subscribe'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-newsletter-subscribe' */
            'partner/modules/citta-newsletter-subscribe/citta-newsletter-subscribe.tsx'),
        $type: 'contentModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-newsletter-subscribe',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-newsletter-subscribe'
    });
        

    isNotRegistered('citta-newsletter-subscribe-pop-up') && (binding.modules['citta-newsletter-subscribe-pop-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-newsletter-subscribe-pop-up' */
            'partner/modules/citta-newsletter-subscribe-pop-up/citta-newsletter-subscribe-pop-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-newsletter-subscribe-pop-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-newsletter-subscribe-pop-up'
    });
        

    isNotRegistered('citta-orderreference') && (binding.modules['citta-orderreference'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-orderreference' */
            'partner/modules/citta-orderreference/citta-orderreference.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-orderreference',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-orderreference'
    });
        

    isNotRegistered('citta-pop-up-copy') && (binding.modules['citta-pop-up-copy'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-pop-up-copy' */
            'partner/modules/citta-pop-up-copy/citta-pop-up-copy.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-pop-up-copy',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-pop-up-copy'
    });
        

    isNotRegistered('citta-product-attribute-companion-product') && (binding.modules['citta-product-attribute-companion-product'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-product-attribute-companion-product' */
            'partner/modules/citta-product-attribute-companion-product/citta-product-attribute-companion-product.tsx'),
        $type: 'contentModule',
        da: [{name:'attributes',  path:'data-actions/accordion/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-product-attribute-companion-product',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-product-attribute-companion-product'
    });
        

    isNotRegistered('citta-product-attribute-link') && (binding.modules['citta-product-attribute-link'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-product-attribute-link' */
            'partner/modules/citta-product-attribute-link/citta-product-attribute-link.tsx'),
        $type: 'contentModule',
        da: [{name:'attributes',  path:'data-actions/accordion/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-product-attribute-link',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-product-attribute-link'
    });
        

    isNotRegistered('citta-product-collection') && (binding.modules['citta-product-collection'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-product-collection' */
            'partner/modules/citta-product-collection/citta-product-collection.tsx'),
        $type: 'containerModule',
        da: [{name:'catelogfeed',  path:'data-actions/category/products-by-similarlooks', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-product-collection',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-product-collection'
    });
        

    isNotRegistered('citta-product-eoq') && (binding.modules['citta-product-eoq'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-product-eoq' */
            'partner/modules/citta-product-eoq/citta-product-eoq.tsx'),
        $type: 'contentModule',
        da: [{name:'attributes',  path:'data-actions/accordion/get-attributes-for-selected-variant', runOn: 0},{name:'productAvailability',  path:'actions/custom-get-product-availabilities-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-product-eoq',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-product-eoq'
    });
        

    isNotRegistered('citta-product-sku') && (binding.modules['citta-product-sku'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-product-sku' */
            'partner/modules/citta-product-sku/citta-product-sku.tsx'),
        $type: 'moduleDefinition',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-product-sku',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-product-sku'
    });
        

    isNotRegistered('citta-product-video') && (binding.modules['citta-product-video'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-product-video' */
            'partner/modules/citta-product-video/citta-product-video.tsx'),
        $type: 'contentModule',
        da: [{name:'attributes',  path:'data-actions/accordion/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-product-video',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-product-video'
    });
        

    isNotRegistered('citta-productpdf-specification') && (binding.modules['citta-productpdf-specification'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-productpdf-specification' */
            'partner/modules/citta-productpdf-specification/citta-productpdf-specification.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'data-actions/accordion/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-productpdf-specification',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-productpdf-specification'
    });
        

    isNotRegistered('citta-promo-banner') && (binding.modules['citta-promo-banner'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-promo-banner' */
            'partner/modules/citta-promo-banner/citta-promo-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-promo-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-promo-banner'
    });
        

    isNotRegistered('citta-search') && (binding.modules['citta-search'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-search' */
            'partner/modules/citta-search/citta-search.tsx'),
        $type: 'contentModule',
        da: [{name:'searchState',  path:'@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-search',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-search'
    });
        

    isNotRegistered('citta-search-result-container') && (binding.modules['citta-search-result-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-search-result-container' */
            'partner/modules/citta-search-result-container/citta-search-result-container.tsx'),
        $type: 'contentModule',
        da: [{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'featureProduct',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'listPageState',  path:'modules/citta-search-result-container/list-page-state', runOn: 0},{name:'products',  path:'modules/citta-search-result-container/actions/get-full-products-by-collection', runOn: 0},{name:'refiners',  path:'modules/citta-search-result-container/actions/get-refiners-for-collection', runOn: 0},{name:'searchConfiguration',  path:'modules/citta-search-result-container/actions/get-mapped-search-configuration', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-search-result-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-search-result-container'
    });
        

    isNotRegistered('citta-sign-up') && (binding.modules['citta-sign-up'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-sign-up' */
            'partner/modules/citta-sign-up/citta-sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-sign-up'
    });
        

    isNotRegistered('citta-stockists') && (binding.modules['citta-stockists'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-stockists' */
            'partner/modules/citta-stockists/citta-stockists.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-stockists',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-stockists'
    });
        

    isNotRegistered('citta-store-location-mobile') && (binding.modules['citta-store-location-mobile'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-store-location-mobile' */
            'partner/modules/citta-store-location-mobile/citta-store-location-mobile.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-store-location-mobile',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-store-location-mobile'
    });
        

    isNotRegistered('citta-store-locations') && (binding.modules['citta-store-locations'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-store-locations' */
            'partner/modules/citta-store-locations/citta-store-locations.tsx'),
        $type: 'moduleDefinition',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-store-locations',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-store-locations'
    });
        

    isNotRegistered('citta-store-locations-v2') && (binding.modules['citta-store-locations-v2'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-store-locations-v2' */
            'partner/modules/citta-store-locations-v2/citta-store-locations-v2.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-store-locations-v2',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-store-locations-v2'
    });
        

    isNotRegistered('citta-store-selector') && (binding.modules['citta-store-selector'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-store-selector' */
            'partner/modules/citta-store-selector/citta-store-selector.tsx'),
        $type: 'contentModule',
        da: [{name:'availabilitiesWithHours',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby', runOn: 1},{name:'productAttributes',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant', runOn: 0},{name:'storeLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-store-selector',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-store-selector'
    });
        

    isNotRegistered('citta-subscribe-newsletter') && (binding.modules['citta-subscribe-newsletter'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-subscribe-newsletter' */
            'partner/modules/citta-subscribe-newsletter/citta-subscribe-newsletter.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-subscribe-newsletter',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-subscribe-newsletter'
    });
        

    isNotRegistered('citta-subscribe-newsletter-form') && (binding.modules['citta-subscribe-newsletter-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-subscribe-newsletter-form' */
            'partner/modules/citta-subscribe-newsletter-form/citta-subscribe-newsletter-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-subscribe-newsletter-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-subscribe-newsletter-form'
    });
        

    isNotRegistered('citta-tab-item') && (binding.modules['citta-tab-item'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-tab-item' */
            'partner/modules/citta-tab-item/citta-tab-item.tsx'),
        $type: 'moduleDefinition',
        da: [{name:'activeTabState',  path:'data-actions/tabs/tab-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-tab-item',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-tab-item'
    });
        

    isNotRegistered('citta-tabs') && (binding.modules['citta-tabs'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-tabs' */
            'partner/modules/citta-tabs/citta-tabs.tsx'),
        $type: 'moduleDefinition',
        da: [{name:'activeTabState',  path:'data-actions/tabs/tab-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-tabs',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-tabs'
    });
        

    isNotRegistered('citta-tile-list-item') && (binding.modules['citta-tile-list-item'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-tile-list-item' */
            'partner/modules/citta-tile-list-item/citta-tile-list-item.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-tile-list-item',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-tile-list-item'
    });
        

    isNotRegistered('citta-unsubscribe') && (binding.modules['citta-unsubscribe'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-unsubscribe' */
            'partner/modules/citta-unsubscribe/citta-unsubscribe.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-unsubscribe',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-unsubscribe'
    });
        

    isNotRegistered('citta-user-subscribed') && (binding.modules['citta-user-subscribed'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-user-subscribed' */
            'partner/modules/citta-user-subscribed/citta-user-subscribed.tsx'),
        $type: 'contentModule',
        da: [{name:'activeCart',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-user-subscribed',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-user-subscribed'
    });
        

    isNotRegistered('citta-wholesale-newsletter-form') && (binding.modules['citta-wholesale-newsletter-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-wholesale-newsletter-form' */
            'partner/modules/citta-wholesale-newsletter-form/citta-wholesale-newsletter-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-wholesale-newsletter-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-wholesale-newsletter-form'
    });
        

    isNotRegistered('citta-wishlist-items') && (binding.modules['citta-wishlist-items'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-citta-wishlist-items' */
            'partner/modules/citta-wishlist-items/citta-wishlist-items.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'cartConfiguration',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'productAvailability',  path:'modules/citta-wishlist-items/actions/get-product-availabilities-citta-wishlist-items', runOn: 1},{name:'products',  path:'modules/citta-wishlist-items/actions/get-items-in-wishlists', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'citta-wishlist-items',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/citta-wishlist-items'
    });
        

    isNotRegistered('hreflang-module') && (binding.modules['hreflang-module'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hreflang-module' */
            'partner/modules/hreflang/hreflang.tsx'),
        $type: 'htmlHeadTagsModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hreflang-module',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hreflang'
    });
        

    isNotRegistered('super-media-gallery') && (binding.modules['super-media-gallery'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-super-media-gallery' */
            'partner/modules/super-media-gallery/super-media-gallery.tsx'),
        $type: 'contentModule',
        da: [{name:'mediaLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id', runOn: 0},{name:'mediaLocationsForSelectedVariant',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-for-selected-variant', runOn: 0},{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'super-media-gallery',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/super-media-gallery'
    });
        

    isNotRegistered('video-player-mobility') && (binding.modules['video-player-mobility'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-video-player-mobility' */
            'partner/modules/video-player-mobility/video-player-mobility.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'video-player-mobility',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/video-player-mobility'
    });
        

        {   
            const actionPath = 'actions/custom-get-category-paths.action';
            binding.dataActions[actionPath] = require('partner/actions/custom-get-category-paths.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-fingerprint.action';
            binding.dataActions[actionPath] = require('partner/actions/get-fingerprint.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-bloc-event.action';
            binding.dataActions[actionPath] = require('partner/actions/post-bloc-event.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-checkout-guest-profile-emarsys.action';
            binding.dataActions[actionPath] = require('partner/actions/post-checkout-guest-profile-emarsys.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-contact-event.action';
            binding.dataActions[actionPath] = require('partner/actions/post-contact-event.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-contact.action';
            binding.dataActions[actionPath] = require('partner/actions/post-contact.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-emarsys-contact-event.action';
            binding.dataActions[actionPath] = require('partner/actions/post-emarsys-contact-event.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-instore-giveaway-emarsys-event.action';
            binding.dataActions[actionPath] = require('partner/actions/post-instore-giveaway-emarsys-event.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-journal-competition.action';
            binding.dataActions[actionPath] = require('partner/actions/post-journal-competition.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-notify-me.action';
            binding.dataActions[actionPath] = require('partner/actions/post-notify-me.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-pop-up-copy.action';
            binding.dataActions[actionPath] = require('partner/actions/post-pop-up-copy.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-wholesale-contact.action';
            binding.dataActions[actionPath] = require('partner/actions/post-wholesale-contact.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-wholesale-optout-contact.action';
            binding.dataActions[actionPath] = require('partner/actions/post-wholesale-optout-contact.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/products-by-category.action';
            binding.dataActions[actionPath] = require('partner/actions/products-by-category.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/products-by-recommendation.action';
            binding.dataActions[actionPath] = require('partner/actions/products-by-recommendation.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'data-actions/contact/submit-contact-commecial-form-data.action';
            binding.dataActions[actionPath] = require('partner/data-actions/contact/submit-contact-commecial-form-data.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'data-actions/contact/submit-contact-form-data.action';
            binding.dataActions[actionPath] = require('partner/data-actions/contact/submit-contact-form-data.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/citta-checkout-payment-instrument-afterpay/not-actions/place-order.action';
            binding.dataActions[actionPath] = require('partner/modules/citta-checkout-payment-instrument-afterpay/not-actions/place-order.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/citta-checkout-payment-instrument/not-actions/place-order.action';
            binding.dataActions[actionPath] = require('partner/modules/citta-checkout-payment-instrument/not-actions/place-order.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-management-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-address-purposes';
            let dataAction = require('partner/common/citta-address/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('account-management-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-country-regions';
            let dataAction = require('partner/common/citta-address/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-citta-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-citta-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-citta-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('b2b-citta-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('business-account-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('business-account-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-address-purposes';
            let dataAction = require('partner/common/citta-address/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('business-account-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-country-regions';
            let dataAction = require('partner/common/citta-address/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('business-account-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-country-state';
            let dataAction = require('partner/common/citta-address/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-address-purposes';
            let dataAction = require('partner/common/citta-address/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-country-regions';
            let dataAction = require('partner/common/citta-address/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-billing-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-country-state';
            let dataAction = require('partner/common/citta-address/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-guest-profile-emarsys')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-guest-profile-emarsys')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-section-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-section-container')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-address-purposes';
            let dataAction = require('partner/common/citta-address/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-country-regions';
            let dataAction = require('partner/common/citta-address/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('checkout-shipping-address')){
            const sanitizedActionPath = 'common/citta-address/actions/get-country-state';
            let dataAction = require('partner/common/citta-address/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = 'actions/custom-get-product-availabilities-for-selected-variant';
            let dataAction = require('partner/actions/custom-get-product-availabilities-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = 'data-actions/accordion/accordion-state-data-action';
            let dataAction = require('partner/data-actions/accordion/accordion-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta')){
            const sanitizedActionPath = 'data-actions/accordion/get-attributes-for-selected-variant';
            let dataAction = require('partner/data-actions/accordion/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-accordion-custom')){
            const sanitizedActionPath = 'data-actions/accordion/accordion-state-data-action';
            let dataAction = require('partner/data-actions/accordion/accordion-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-accordion-item-custom')){
            const sanitizedActionPath = 'data-actions/accordion/accordion-state-data-action';
            let dataAction = require('partner/data-actions/accordion/accordion-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-account-management-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-account-management-address')){
            const sanitizedActionPath = 'data-actions/address/get-address-purposes';
            let dataAction = require('partner/data-actions/address/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-account-management-address')){
            const sanitizedActionPath = 'data-actions/address/get-country-regions';
            let dataAction = require('partner/data-actions/address/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-account-subscription')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-b2b-account-profile')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attribute-definitions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-b2b-account-profile')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-b2b-account-welcome-tile')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-b2b-wishlist-items')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-b2b-wishlist-items')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-b2b-wishlist-items')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-b2b-wishlist-items')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-b2b-wishlist-items')){
            const sanitizedActionPath = 'modules/citta-b2b-wishlist-items/actions/get-items-in-wishlists';
            let dataAction = require('partner/modules/citta-b2b-wishlist-items/actions/get-items-in-wishlists');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-b2b-wishlist-items')){
            const sanitizedActionPath = 'modules/citta-b2b-wishlist-items/actions/get-product-availabilities-citta-b2b-wishlist-items';
            let dataAction = require('partner/modules/citta-b2b-wishlist-items/actions/get-product-availabilities-citta-b2b-wishlist-items');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-category-paths');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-buybox')){
            const sanitizedActionPath = 'actions/custom-get-product-availabilities-for-selected-variant';
            let dataAction = require('partner/actions/custom-get-product-availabilities-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-cart')){
            const sanitizedActionPath = 'modules/citta-cart/actions/get-pickup-options-for-citta-cartlines';
            let dataAction = require('partner/modules/citta-cart/actions/get-pickup-options-for-citta-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-category-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-category-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout')){
            const sanitizedActionPath = 'modules/citta-checkout/actions/get-products-in-active-citta-checkout-cart';
            let dataAction = require('partner/modules/citta-checkout/actions/get-products-in-active-citta-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-billing-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-billing-address')){
            const sanitizedActionPath = 'data-actions/address/get-address-purposes';
            let dataAction = require('partner/data-actions/address/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-billing-address')){
            const sanitizedActionPath = 'data-actions/address/get-country-regions';
            let dataAction = require('partner/data-actions/address/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-billing-address')){
            const sanitizedActionPath = 'data-actions/address/get-country-state';
            let dataAction = require('partner/data-actions/address/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-billing-address')){
            const sanitizedActionPath = 'data-actions/click-and-collect/shipping-types';
            let dataAction = require('partner/data-actions/click-and-collect/shipping-types');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-customer-account-payment')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-gift-card')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-guest-profile')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-guest-profile')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-gwp')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-gwp')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-gwp')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-gwp')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-gwp')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-gwp')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-gwp')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-gwp')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-gwp')){
            const sanitizedActionPath = 'modules/citta-checkout-gwp/actions/get-products-in-active-citta-checkout-gwp-cart';
            let dataAction = require('partner/modules/citta-checkout-gwp/actions/get-products-in-active-citta-checkout-gwp-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-ogty')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-ogty')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-ogty')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-ogty')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-ogty')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-ogty')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-ogty')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-ogty')){
            const sanitizedActionPath = 'modules/citta-checkout-ogty/actions/get-products-in-active-citta-checkout-ogty-cart';
            let dataAction = require('partner/modules/citta-checkout-ogty/actions/get-products-in-active-citta-checkout-ogty-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart';
            let dataAction = require('@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-payment-instrument-afterpay')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart';
            let dataAction = require('@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/actions/get-products-in-active-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-payment-instrument-afterpay')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-payment-instrument-afterpay')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-payment-instrument-afterpay')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-payment-instrument-afterpay')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-payment-instrument-afterpay')){
            const sanitizedActionPath = 'modules/citta-checkout-payment-instrument-afterpay/actions/get-card-payment-accept-point';
            let dataAction = require('partner/modules/citta-checkout-payment-instrument-afterpay/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address')){
            const sanitizedActionPath = 'data-actions/address/get-address-purposes';
            let dataAction = require('partner/data-actions/address/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address')){
            const sanitizedActionPath = 'data-actions/address/get-country-regions';
            let dataAction = require('partner/data-actions/address/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address')){
            const sanitizedActionPath = 'data-actions/address/get-country-state';
            let dataAction = require('partner/data-actions/address/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address-intl')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-address-purposes');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address-intl')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-regions');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address-intl')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state';
            let dataAction = require('@msdyn365-commerce-modules/address/dist/lib/actions/get-country-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address-intl')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address-intl')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-address';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-address');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address-intl')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address-intl')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-checkout-shipping-address-intl')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-create-gift-card')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-create-gift-card')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-create-gift-card')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-create-gift-card')){
            const sanitizedActionPath = 'data-actions/product-info/get-keyed-in-price';
            let dataAction = require('partner/data-actions/product-info/get-keyed-in-price');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-create-gift-card')){
            const sanitizedActionPath = 'data-actions/product-info/get-keyed-in-price-error';
            let dataAction = require('partner/data-actions/product-info/get-keyed-in-price-error');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-create-gift-card')){
            const sanitizedActionPath = 'data-actions/product-info/get-product-configure-error-state';
            let dataAction = require('partner/data-actions/product-info/get-product-configure-error-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-create-gift-card')){
            const sanitizedActionPath = 'data-actions/product-info/get-selected-quantity';
            let dataAction = require('partner/data-actions/product-info/get-selected-quantity');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquirenow')){
            const sanitizedActionPath = 'data-actions/accordion/accordion-state-data-action';
            let dataAction = require('partner/data-actions/accordion/accordion-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-dimensions-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-price-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-product-availabilities-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-ratings-summary');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-enquireonly-buybox')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-freight-charges')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-freight-charges')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-freight-charges')){
            const sanitizedActionPath = 'data-actions/product-info/get-attributes-for-selected-variant';
            let dataAction = require('partner/data-actions/product-info/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-freight-charges')){
            const sanitizedActionPath = 'data-actions/product-info/get-selected-quantity';
            let dataAction = require('partner/data-actions/product-info/get-selected-quantity');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-freight-charges')){
            const sanitizedActionPath = 'data-actions/product-quantity/product-quantity-state-data-action';
            let dataAction = require('partner/data-actions/product-quantity/product-quantity-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-gift-card-creation')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-org-unit-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-gift-card-creation')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-gift-card-creation')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-gift-card-creation')){
            const sanitizedActionPath = 'data-actions/product-info/get-keyed-in-price';
            let dataAction = require('partner/data-actions/product-info/get-keyed-in-price');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-gift-card-creation')){
            const sanitizedActionPath = 'data-actions/product-info/get-keyed-in-price-error';
            let dataAction = require('partner/data-actions/product-info/get-keyed-in-price-error');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-gift-card-creation')){
            const sanitizedActionPath = 'data-actions/product-info/get-product-configure-error-state';
            let dataAction = require('partner/data-actions/product-info/get-product-configure-error-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-gift-card-creation')){
            const sanitizedActionPath = 'data-actions/product-info/get-selected-quantity';
            let dataAction = require('partner/data-actions/product-info/get-selected-quantity');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-inv-dlv-banner')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-journal-posts')){
            const sanitizedActionPath = 'data-actions/journal/get-journal-posts';
            let dataAction = require('partner/data-actions/journal/get-journal-posts');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-media-gallery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-media-gallery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-newsletter-subscribe')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-orderreference')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-orderreference')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-product-attribute-companion-product')){
            const sanitizedActionPath = 'data-actions/accordion/get-attributes-for-selected-variant';
            let dataAction = require('partner/data-actions/accordion/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-product-attribute-link')){
            const sanitizedActionPath = 'data-actions/accordion/get-attributes-for-selected-variant';
            let dataAction = require('partner/data-actions/accordion/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-product-collection')){
            const sanitizedActionPath = 'data-actions/category/products-by-similarlooks';
            let dataAction = require('partner/data-actions/category/products-by-similarlooks');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-product-eoq')){
            const sanitizedActionPath = 'actions/custom-get-product-availabilities-for-selected-variant';
            let dataAction = require('partner/actions/custom-get-product-availabilities-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-product-eoq')){
            const sanitizedActionPath = 'data-actions/accordion/get-attributes-for-selected-variant';
            let dataAction = require('partner/data-actions/accordion/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-product-sku')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-product-video')){
            const sanitizedActionPath = 'data-actions/accordion/get-attributes-for-selected-variant';
            let dataAction = require('partner/data-actions/accordion/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-productpdf-specification')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-productpdf-specification')){
            const sanitizedActionPath = 'data-actions/accordion/get-attributes-for-selected-variant';
            let dataAction = require('partner/data-actions/accordion/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-search')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action';
            let dataAction = require('@msdyn365-commerce-modules/search-utilities/dist/lib/search-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-search-result-container')){
            const sanitizedActionPath = 'modules/citta-search-result-container/actions/get-full-products-by-collection';
            let dataAction = require('partner/modules/citta-search-result-container/actions/get-full-products-by-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-search-result-container')){
            const sanitizedActionPath = 'modules/citta-search-result-container/actions/get-mapped-search-configuration';
            let dataAction = require('partner/modules/citta-search-result-container/actions/get-mapped-search-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-search-result-container')){
            const sanitizedActionPath = 'modules/citta-search-result-container/actions/get-refiners-for-collection';
            let dataAction = require('partner/modules/citta-search-result-container/actions/get-refiners-for-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-search-result-container')){
            const sanitizedActionPath = 'modules/citta-search-result-container/list-page-state';
            let dataAction = require('partner/modules/citta-search-result-container/list-page-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-store-selector')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-store-selector')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-store-selector')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-full-available-inventory-nearby');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-store-selector')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-store-location-information');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-tab-item')){
            const sanitizedActionPath = 'data-actions/tabs/tab-state-data-action';
            let dataAction = require('partner/data-actions/tabs/tab-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-tabs')){
            const sanitizedActionPath = 'data-actions/tabs/tab-state-data-action';
            let dataAction = require('partner/data-actions/tabs/tab-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-user-subscribed')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-wishlist-items')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-cart-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-wishlist-items')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-wishlist-items')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-wishlist-items')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-wishlist-items')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-wishlist-items')){
            const sanitizedActionPath = 'modules/citta-wishlist-items/actions/get-items-in-wishlists';
            let dataAction = require('partner/modules/citta-wishlist-items/actions/get-items-in-wishlists');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('citta-wishlist-items')){
            const sanitizedActionPath = 'modules/citta-wishlist-items/actions/get-product-availabilities-citta-wishlist-items';
            let dataAction = require('partner/modules/citta-wishlist-items/actions/get-product-availabilities-citta-wishlist-items');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('super-media-gallery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-by-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('super-media-gallery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-media-locations-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('super-media-gallery')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};